import { useCallback, useContext } from "react";
import toast from "react-hot-toast";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { iCurrentTripContext } from "../../../context/currentTripContext/currentTripContextInterface";
import { useCurrentTripContext } from "../../../context/currentTripContext/currentTripContext";
import { useNavigationUrl } from "../../../hooks/useNavigationUrl";
import { ROUTES } from "../../../constant";
import { ScreenTypes } from "../../../enums";
import { TRIP_DETAILS_TABS } from "../../TripManagement/tripDetailsPage/tripDetailsPageConstant";
import { MY_TRIP_TABS } from "../../TripManagement/myTripsPage/components/myTripsConstants";

export default function useOpenBookedTrip() {
  const {
    bookedtransIds,
    setTripOrItinearyId,
    setFirstScreen,
    setScreen,
    setMyTripActiveTab,
    setIsUserNavigatingFromPaymentGateway,
    userInfo,
    setIsUserJustBookedTrip,
    setActiveTripDetailsTab,
    setFetchItineraryDetails,
  }: iGlobalContext = useContext(StateContext);
  const { getCurrentTrip }: iCurrentTripContext = useCurrentTripContext();
  const { navigateWithParams } = useNavigationUrl();
  const { flightTransactionId = "", hotelTransactionId = "", activityTransactionId = "" } = bookedtransIds || {};

  return useCallback(
    (tripId: string, isMobile: boolean) => {
      if (activityTransactionId && !flightTransactionId && !hotelTransactionId) {
        setActiveTripDetailsTab(TRIP_DETAILS_TABS.ACTIVITIES);
      } else if (flightTransactionId && !hotelTransactionId) {
        setActiveTripDetailsTab(TRIP_DETAILS_TABS.FLIGHTS);
      } else if (hotelTransactionId && !flightTransactionId) {
        setActiveTripDetailsTab(TRIP_DETAILS_TABS.HOTELS);
      } else {
        setActiveTripDetailsTab(TRIP_DETAILS_TABS.DAILY_PLANS);
      }
      setIsUserJustBookedTrip(true);

      getCurrentTrip(userInfo?.id);

      setTripOrItinearyId(tripId);
      setFetchItineraryDetails(true);
      if (isMobile) {
        window.history.pushState({}, "", ROUTES.MyTrips);
        navigateWithParams(ROUTES.TripDetails);
      } else {
        setIsUserNavigatingFromPaymentGateway(true);
        navigateWithParams(ROUTES.Home, { replace: true });
        setFirstScreen(ScreenTypes.MyTrips);
        setScreen(ScreenTypes.TripDetails);
      }
      toast.dismiss();
      setMyTripActiveTab(MY_TRIP_TABS.BOOKED);
    },
    [
      activityTransactionId,
      flightTransactionId,
      hotelTransactionId,
      getCurrentTrip,
      navigateWithParams,
      setActiveTripDetailsTab,
      setFetchItineraryDetails,
      setFirstScreen,
      setIsUserJustBookedTrip,
      setIsUserNavigatingFromPaymentGateway,
      setMyTripActiveTab,
      setScreen,
      setTripOrItinearyId,
      userInfo?.id,
    ]
  );
}
